<template>
  <div class="page">
    <div>
      <el-row :gutter="24">
        <el-col :span="12">
          <div v-if="!isHadSetted">
            您还未设置过推送信息,是否设置？<el-button type="primary" @click="toPushSetting">立即设置</el-button>
          </div>&nbsp;
        </el-col>
        <el-col :span="12" class="text right">
          <a href="/static/api/风焱接口文档.html" style="color:#269BDA;">
            <el-button type="primary" plain icon="el-icon-download">推送接口文档_V1.0(20181206)</el-button>
          </a>
        </el-col>
      </el-row>
    </div>
    <div v-if="isHadSetted">
      <el-form label-width="100px">
        <el-row :gutter="24" class="text left font-medium">
          <span>基本设置</span>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="12">
            <el-form-item label="登录绑定" >
              <span v-if="!pushSettingData.isHadBindPushAccount">
                <el-button type="primary" @click="toBindPushAccount" >立即绑定</el-button>
              </span>
              <span v-else>
                <i class="el-icon-check success">已绑定</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button type="primary" plain @click="toBindPushAccount">重新绑定</el-button>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="12">
            <el-form-item label="凭证地址">
              <el-input v-model="pushSettingData.pushTokenUrl"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回推地址">
              <el-input v-model="pushSettingData.pushUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="12">
            <el-form-item label="开启推送">
              <el-switch v-model="pushSettingData.isPush" @change="isPushClick"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开启重推">
              <el-switch v-model="pushSettingData.isRePush" @change="rePushClick"></el-switch>&nbsp;&nbsp;,每&nbsp;<el-input-number v-model="pushSettingData.pushFrequency" :min="1" :max="24"></el-input-number>&nbsp;小时推一次，至作业停止日结束
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="12">
            <el-form-item label="使用老版本">
              <el-switch v-model="pushSettingData.isUseOld"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="推送次数">
              <el-input-number
                v-model="pushSettingData.pushTimes"
                :min="1"
                :max="12"></el-input-number>(老版有效)
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="12">
            <el-form-item label="仅推送云电猫主动更新信息">
              <el-switch v-model="pushSettingData.isOnlyPushActiveChange"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="24">
            <el-form-item label="重推时间">
              <el-checkbox :indeterminate="pushWorkDayIndeterminate" v-model="pushWorkDayCheckAll" @change="handleCheckAllChange">全选</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="pushSettingData.pushWorkDay" @change="handleCheckedWorkDayChange">
                <el-checkbox
                  v-for="item in pushWorkDayOption"
                  :key="item.value"
                  :label="item.value">{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-form-item label="">
            <el-col :span="6">
              <el-time-picker
                v-model="pushWorkTimeStart"
                format="HH:mm:ss"
                value-format="HH:mm:ss">
              </el-time-picker>
            </el-col>
            <el-col :span="6">
              <el-time-picker
                v-model="pushWorkTimeEnd"
                format="HH:mm:ss"
                value-format="HH:mm:ss">
              </el-time-picker>
            </el-col>
          </el-form-item>
      </el-row>
        <el-row :gutter="24" class="text left font-medium">
          <span>推送条件</span>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="24">
            <el-form-item label="案件状态">
              <el-checkbox-group v-model="pushSettingData.caseStatus">
                <el-checkbox
                  v-for="item in caseStatusOption"
                  :key="item.modelCode"
                  :label="item.modelCode">{{item.modelName}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="24">
            <el-form-item label="作业状态">
              <el-checkbox-group v-model="pushSettingData.urgeStatus">
                <el-checkbox
                  v-for="item in urgeStatusOption"
                  :key="item.value"
                  :label="item.value">{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="24">
            <el-form-item label="本人状态">
              <el-checkbox-group v-model="pushSettingData.selfContactStatus">
                <el-checkbox
                  v-for="item in selfContactStatusOption"
                  :key="item.modelCode"
                  :label="item.modelCode">{{item.modelName}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="24">
            <el-form-item label="联系人状态">
              <el-checkbox-group v-model="pushSettingData.noSelfContactStatus">
                <el-checkbox
                  v-for="item in noSelfContactStatusOption"
                  :key="item.modelCode"
                  :label="item.modelCode">{{item.modelName}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="text left font-medium">
          <span>回推参数</span>
        </el-row>
        <el-row :gutter="24" class="text left">
          <el-col :span="24">
            <el-form-item label="回推参数">
              <el-checkbox-group v-model="pushSettingData.pushBack">
                <el-checkbox
                  v-for="item in pushBackOption"
                  :key="item.value"
                  :label="item.value"
                  :disabled="item.disable">{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24" class="text center">
            <el-button type="primary" @click="pushSettingSave">保存</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="dialog">
      <!-- 绑定日蚀账号 -->
      <el-dialog
        title="绑定回推账号"
        :visible.sync="bindPushAccountVisible"
        width="50%"
        center>
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="回推账号:">
            <el-input
              v-model="pushAccountBindReq.userName"
              style="width: 80%;"
              placeholder="长度4~64"
              minlength="4"
              maxlength="128"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="回推密码:">
            <el-input
              v-model="pushAccountBindReq.password"
              style="width: 80%;"
              placeholder="请输入加密后的推送密码,长度16~128"
              type="password"
              minlength="32"
              maxlength="128"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="bindPushAccountVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="bindPushAccountSave" size="small">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
const allPushWorkDayValue = ['1', '2', '3', '4', '5', '6', '7'];
export default {
  props: [
    'companyIdTemp'
  ],
  data() {
    return {
      pushSettingGetReq: {},
      pushSettingData: {},
      isHadSetted: false,
      isShowPushSettingSaveCancelButton: false,
      pushSettingSaveReq: {},
      pushAccountBindReq: {
        id: '',
        companyId: '',
        userName: '',
        password: ''
      },
      caseStatusOption: [],
      urgeStatusOption: [
        {
          value: '1',
          label: '作业中'
        }, {
          value: '-1',
          label: '暂停作业'
        }, {
          value: '2',
          label: '作业完成'
        }
      ],
      selfContactStatusOption: [],
      noSelfContactStatusOption: [],
      contactStatusType: {
        benrendianhua: 'benrendianhuaContactStatus',
        zhixidianhua: 'zhixidianhuaContactStatus'
      },
      pushBackOption: [
        {
          value: 'aCaseId',
          label: '进件号',
          disable: true
        }, {
          value: 'batchNo',
          label: '批次号',
          disable: true
        }, {
          value: 'caseStatus',
          label: '案件状态',
          disable: false
        }, {
          value: 'urgeStatus',
          label: '作业状态',
          disable: false
        }, {
          value: 'selfContactStatus',
          label: '本人状态',
          disable: false
        }, {
          value: 'noSelfContactStatus',
          label: '联系状态',
          disable: false
        }, {
          value: 'label',
          label: '标签',
          disable: false
        }, {
          value: 'deduction',
          label: '减免金额',
          disable: false
        }, {
          value: 'lastAnswerTime',
          label: '最新联系时间',
          disable: false
        }, {
          value: 'promisePayTime',
          label: '承诺还款时间',
          disable: false
        }, {
          value: 'contactStatus',
          label: '当前联系人联系状态',
          disable: false
        }, {
          value: 'lastResponseTime',
          label: '回复短信时间',
          disable: false
        }
      ],
      pushWorkDayOption: [
        {
          value: '1',
          label: '周一'
        }, {
          value: '2',
          label: '周二'
        }, {
          value: '3',
          label: '周三'
        }, {
          value: '4',
          label: '周四'
        }, {
          value: '5',
          label: '周五'
        }, {
          value: '6',
          label: '周六'
        }, {
          value: '7',
          label: '周日'
        }
      ],
      allPushWorkDayValue,
      pushWorkDayCheckAll: false,
      pushWorkDayIndeterminate: true,
      bindPushAccountVisible: false,
      pushWorkTimeStart: '',
      pushWorkTimeEnd: ''
    };
  },
  watch: {
    companyIdTemp(companyId) {
      this.getPushSettingData(companyId);
    }
  },
  mounted() {
    this.getCaseStatusOption();
    this.getSelfContactStatusOption();
    this.getNoSelfContactStatusOption();
  },
  methods: {
    getPushSettingData(companyId) {
      this.pushSettingGetReq.companyId = companyId;
      this.$ajax({
        url: '/company/getPushSetting',
        data: this.pushSettingGetReq
      }).then((res) => {
        this.$nextTick(() => {
          if (res.data) {
            // 有配置
            this.isHadSetted = true;
            if (res.data.pushTokenUrl) {
              // 有其他设置
              this.pushSettingData = res.data;
              // json串转化成前端需要的数组
              if (this.pushSettingData.caseStatus) {
                this.pushSettingData.caseStatus = JSON.parse(this.pushSettingData.caseStatus);
              }
              if (this.pushSettingData.urgeStatus) {
                this.pushSettingData.urgeStatus = JSON.parse(this.pushSettingData.urgeStatus);
              }
              if (this.pushSettingData.selfContactStatus) {
                this.pushSettingData.selfContactStatus = JSON.parse(this.pushSettingData.selfContactStatus);
              }
              if (this.pushSettingData.noSelfContactStatus) {
                this.pushSettingData.noSelfContactStatus = JSON.parse(this.pushSettingData.noSelfContactStatus);
              }
              if (this.pushSettingData.pushBack) {
                this.pushSettingData.pushBack = JSON.parse(this.pushSettingData.pushBack);
              } else {
                // 设置默认值
                this.pushSettingData.pushBack = ['aCaseId', 'batchNo'];
              }
              // 推送日
              if (this.pushSettingData.pushWorkDay) {
                const pushWorkDayArr = this.pushSettingData.pushWorkDay.split('&');
                const pushWorkDayValues = [];
                this.allPushWorkDayValue.forEach((element) => {
                  if (pushWorkDayArr[element - 1] === '1') {
                    pushWorkDayValues.push(element);
                  }
                });
                this.pushSettingData.pushWorkDay = pushWorkDayValues;
              }
              // 推送时间
              if (this.pushSettingData.pushWorkTime) {
                const pushWorkTimeArr = this.pushSettingData.pushWorkTime.split('-');
                this.pushWorkTimeStart = pushWorkTimeArr[0];
                this.pushWorkTimeEnd = pushWorkTimeArr[1];
              }
            } else {
              // 无其他配置
              this.pushSettingData = this.getDefaultPushSetting();
            }
            this.pushSettingData.isHadBindPushAccount = res.data.isHadBindPushAccount;
            this.pushSettingData.id = res.data.id;
            this.pushSettingData.companyId = res.data.companyId;
          } else {
            this.isHadSetted = false;
            this.pushSettingData = this.getDefaultPushSetting();
          }
        });
      });
    },
    toPushSetting() {
      this.isHadSetted = !this.isHadSetted;
    },
    getDefaultPushSetting() {
      this.pushWorkTimeStart = '08:00:00';
      this.pushWorkTimeEnd = '21:00:00';
      return {
        id: '',
        companyId: this.pushSettingGetReq.companyId,
        pushTokenUrl: '',
        pushUrl: '',
        pushWorkDay: ['1', '2', '3', '4', '5'],
        pushWorkTime: '',
        caseStatus: [],
        urgeStatus: [],
        selfContactStatus: [],
        noSelfContactStatus: [],
        pushBack: ['aCaseId', 'batchNo'],
        isPush: false,
        isRePush: false,
        pushFrequency: '',
        pushTimes: '',
        isUseOld: false,
        isHadBindPushAccount: false,
        isOnlyPushActiveChange: false
      };
    },
    pushSettingSave() {
      this.pushSettingData.pushWorkTime = this.pushWorkTimeStart.concat('-').concat(this.pushWorkTimeEnd);
      if (!this.pushSettingData.isOnlyPushActiveChange) {
        this.pushSettingData.isOnlyPushActiveChange = false;
      }
      this.pushSettingSaveReq = this.pushSettingData;
      this.$ajax({
        url: '/company/savePushSetting',
        method: 'POST',
        prompt: true,
        data: this.pushSettingSaveReq
      }).then(() => {
        this.getPushSettingData(this.pushSettingGetReq.companyId);
      });
    },
    getCaseStatusOption() {
      this.$ajax({
        url: '/dict/getCaseStatusParam',
        method: 'GET'
      }).then((res) => {
        this.caseStatusOption = res.data;
      });
    },
    getSelfContactStatusOption() {
      this.$ajax({
        url: '/dict/getContactStatusParam',
        data: { contactStatusType: this.contactStatusType.benrendianhua },
        method: 'POST'
      }).then((res) => {
        this.selfContactStatusOption = res.data;
      });
    },
    getNoSelfContactStatusOption() {
      this.$ajax({
        url: '/dict/getContactStatusParam',
        data: { contactStatusType: this.contactStatusType.zhixidianhua },
        method: 'POST'
      }).then((res) => {
        this.noSelfContactStatusOption = res.data;
      });
    },
    bindPushAccountSave() {
      if (this.pushSettingData) {
        this.pushAccountBindReq.id = this.pushSettingData.id;
      }
      this.pushAccountBindReq.companyId = this.pushSettingGetReq.companyId;
      this.$ajax({
        url: '/company/bindPushAccount',
        method: 'POST',
        prompt: true,
        data: this.pushAccountBindReq
      }).then(() => {
        this.bindPushAccountVisible = false;
        this.getPushSettingData(this.pushSettingGetReq.companyId);
      });
    },
    toBindPushAccount() {
      this.pushAccountBindReq = {};
      this.bindPushAccountVisible = true;
    },
    handleCheckAllChange(val) {
      this.pushSettingData.pushWorkDay = val ? this.allPushWorkDayValue : [];
      this.pushWorkDayIndeterminate = false;
    },
    handleCheckedWorkDayChange(val) {
      const checkedCount = val.length;
      this.pushWorkDayCheckAll = checkedCount === this.allPushWorkDayValue.length;
      this.pushWorkDayIndeterminate = checkedCount > 0 && checkedCount < this.allPushWorkDayValue.length;
    },
    // 点击重推校验
    rePushClick() {
      if (this.pushSettingData.isRePush && !this.pushSettingData.isPush) {
        // 重推开启,如果推送关闭,提示
        this.pushSettingData.isRePush = false;
        this.$message.error('推送开关开启,重推才能开启!');
      }
    },
    // 点击开启推送
    isPushClick() {
      if (!this.pushSettingData.isPush && this.pushSettingData.isRePush) {
        // 推送关闭,如果重推打开,自动关闭
        this.pushSettingData.isRePush = false;
      }
    }
  }
};
</script>
<style scoped>
.el-checkbox {
  margin-right: 30px;
}
.el-checkbox+.el-checkbox {
  margin-left: 0px;
}
.success {
  color: #00C700
}
</style>




// WEBPACK FOOTER //
// src/page/main/company/interfacePush.vue